<!-- 上传文件组件 -->
<template>
    <div>
        <!-- <el-dialog title="文件上传" :visible.sync="diaFile" width="600px" :before-close="handleClose"> -->
        <div class="fileBox">
            <el-form ref="form" label-width="80px">
                <el-form-item label="编码">
                    <el-input size="mini" v-model="codingNum" placeholder="请输入编码"></el-input>
                </el-form-item>
            </el-form>
            <div style="margin-left: 80px;padding: 10px 0;">
                <p style="color: red; font-size: 18px;">请上传规格为21cm×29.7cm（210mm×297mm）的图片</p>
            </div>
            <div class="updata">
                <el-upload accept="image/*,.pdf" class="upload-demo" ref="upload" :action="requesUrl + '/upload/fileupload'" :headers="token" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :multiple="true"
                           :limit="20" :on-success="handleAvatarSuccess" :auto-upload="true" :on-exceed="handleExceed" list-type="picture">
                    <!-- 仅「本地上传」作为触发区，避免其他按钮抢占首次点击 -->
                    <el-button slot="trigger" size="mini" type="success">本地上传</el-button>
                    <el-button size="mini" type="primary" @click.stop="showUploadDialog">拖拽上传</el-button>
                    <el-button class="gpy" @click.stop="openHighBeatMeter" size="mini" type="primary" icon="el-icon-video-camera">良田高拍仪</el-button>
                    <el-button v-if="isGPY" class="gpy" @click.stop="openHighBeatMeter1" size="mini" type="primary" icon="el-icon-video-camera">其他高拍仪</el-button>
                    <el-button class="gpy" v-if="printScanShow" @click.stop="scanUpload" size="mini" type="primary" icon="el-icon-video-camera">扫描仪上传</el-button>
                    <el-button class="gpy" size="mini" type="primary" @click.stop="submitUpload">保存</el-button>
                </el-upload>
            </div>
        </div>
        <el-dialog title="高拍仪拍照" destroy-on-close :visible.sync="dialogGPY" width="900px" style="overflow: hidden;height: 700px;" :before-close="handleClosegpy" append-to-body>
            <!-- 高拍仪视频预览区 -->
            <div id="myactive">
                <span>图片质量:</span> <el-select id="view1_mode" v-model="altimeterData.quality">
                    <el-option label="默认质量" value="0"></el-option>
                    <el-option label="高质量" value="1"></el-option>
                    <el-option label="较高质量" value="2"></el-option>
                    <el-option label="中质量" value="3"></el-option>
                    <el-option label="较低质量" value="4"></el-option>
                    <el-option label="低质量" value="5"></el-option>
                </el-select>
                <span>色彩模式:</span><el-select size="mini" inline v-model="altimeterData.ColorMode">
                    <el-option label="白纸印章" value="3"></el-option>
                    <el-option label="彩色" value="0"></el-option>
                    <el-option label="黑白" value="2"></el-option>
                </el-select>
                <el-button style="margin-left:10px" @click="rotate(90)" type="primary" size="mini" icon="el-icon-refresh-left" circle></el-button>
                <el-button style="margin-left:10px" @click="rotate(270)" type="primary" size="mini" icon="el-icon-refresh-right" circle></el-button>
                <span style="margin-left:10px">剪切值:</span>
                <el-input-number style="margin-left:10px ;" v-model="altimeterData.deskewval" size="mini"></el-input-number>
                <span style="margin-left:10px">图片剪切:</span>
                <el-switch style="margin-left:5px ;" @change="delBlackBoard" v-model="switchValue" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>

            </div>
            <div style="display: flex; justify-content: flex-end;">
                <el-button style="margin-left:10px" @click="view1_scan" type="primary" size="mini">兼容拍照</el-button>
                <el-button style="margin-left:10px" @click="view2_scan" type="primary" size="mini">拍照</el-button>
            </div>
            <div class="view-warp">
                <div id="view">
                    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头">
                </div>
                <!-- 缩略图 -->
                <div id="suoluetu">
                    <div v-for="(item, index) in img_base64List" :key="item" class="imgList">
                        <!-- <img :src="item"> -->
                        <el-image style="width: 100px; height: 100px;margin-bottom: 5px;" :src="item" :preview-src-list="img_base64List">
                        </el-image>
                        <el-button type="danger" @click="delImgList(index)" size="mini">删除</el-button>
                    </div>

                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelGpy">取 消</el-button>
                <el-button type="primary" @click="congirmGpyFile">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogImg" width="80%" append-to-body>
            <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width:100%">
        </el-dialog>
        <DragUpload ref="dragUpload" title="文件上传" accept="image/*" :multiple="true" :limit="100" @confirm="onUploadConfirm" />
        <el-dialog title="扫描仪上传" destroy-on-close :visible.sync="scanShow" width="80%" append-to-body top="20px">
            <scannerPlugin v-if="scanShow" ref="scannerPlugin" @submit="onSubmit"></scannerPlugin>
        </el-dialog>
        <el-dialog title="高拍仪上传" destroy-on-close :visible.sync="photographShow" width="75%" append-to-body top="20px">
            <photograph v-if="photographShow" ref="photograph" @submit="photographSubmit"></photograph>
        </el-dialog>
    </div>
</template>
<script>
import axios from 'axios'
import {
    upFile,
} from "@/service/printApi.js";
import photograph from './photograph.vue';
var socket = ''
var imgList = []
export default {
    components: { photograph },

    name: "upDataFile",
    data() {
        //这里存放数据
        return {
            token: { token: sessionStorage.getItem('token') },
            diaFile: false,
            fileList: [], //文件列表
            requesUrl: '',
            imgUrl: '',
            gpy: false,
            selectFileIds: [],
            view1_mode_list: [],
            view1_resolution_list: [],
            img_base64List: [],
            dialogGPY: false,
            imageList: imgList,
            codingNum: '',
            imageUrl: '',
            dialogImg: false,
            isChange: false,
            field: '',
            view1_mode_selected: '1',
            view1_resolution_selected: '',
            altimeterData: {
                "filepath": "base64",
                "rotate": "0",
                "cutpage": "0",
                "camidx": "0",
                "ColorMode": "0",
                "quality": "1",
                "deskew": "1",
                "deskewval": 50
            },
            switchValue: false,
            //-------------
            scanShow: false,
            printScanShow: false,
            isGPY: false,
            //---------其他高拍仪
            photographShow: false,
            _isUploading: false, // 标记是否正在上传中

        }
    },
    props: {
        upDataUrl: {
            type: String,
            default: () => {
                return ""
            }
        },
    },
    //方法集合
    methods: {
        openHighBeatMeter1() {
            this.photographShow = true
        },
        photographSubmit(imgList) {
            if (imgList) {
                var list = JSON.parse(JSON.stringify(imgList))
                list.forEach((item) => {
                    var arr = this.fileList.filter((val) => val.name == item.fileName)
                    if (arr.length == 0) {
                        this.fileList.push({
                            ...item,
                            name: item.fileName,
                            url: this.imgUrl + "/" + item.fileUrl,
                        });
                    }
                })
            }
            this.photographShow = false
        },
        scanUpload() {
            this.scanShow = true
        },
        onSubmit(scannedImages) {
            var list = JSON.parse(JSON.stringify(scannedImages))
            list.forEach((item) => {
                var arr = this.fileList.filter((val) => val.name == item.fileName)
                if (arr.length == 0) {
                    this.fileList.push({
                        ...item,
                        name: item.fileName,
                        url: this.imgUrl + "/" + item.fileUrl,
                    });
                }
            })
            this.scanShow = false
        },
        showUploadDialog() {
            this.$refs.dragUpload.open();
        },
        onUploadConfirm(files) {
            console.log('上传的文件:', files);
            files.forEach(item => {
                this.fileList.push({
                    fileUrl: item.fileUrl,
                    url: this.imgUrl + "/" + item.fileUrl,
                    fileName: item.fileName,
                    fileId: item.fileId,
                })
            })
        },
        delBlackBoard(e) {
            let openFun = 0
            if (e == true) {
                openFun = 1
            }
            console.log(this.switchValue, e)
            this.getStatus(openFun)
        },
        getStatus(e) {//拿状太，去黑边
            axios.post("http://127.0.0.1:38088/video=status").then((res) => {
                console.log(res)
                if (res.data.code == 0) {
                    setTimeout(() => {
                        let data = { "camidx": '0', "open": String(e) }
                        axios.post("http://127.0.0.1:38088/dvideo=cameradeskew", JSON.stringify(data)).then((res) => {
                        })
                    }, 500)
                }
            })
        },
        //删除列表图片
        delImgList(index) {
            this.img_base64List.splice(index, 1)
        },

        // 旋转
        rotate(angle) {
            let data = { "camidx": '0', "rotate": String(angle) }
            axios.post("http://127.0.0.1:38088/video=rotate", JSON.stringify(data)).then((res) => {
            })
        },

        // 切换主摄像头视频模式，重新加载主摄像头分辨率
        view1_mode_change(val) {
            let data = { "camidx": '0', "mode": val }
            axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(data)).then((res) => {
                let resolution_list = res.data.data.split("|");
                view1_resolution_selected = resolution_list[0]
                this.view1_resolution_list = []
                for (var i = 0; i < resolution_list.length; i++) {
                    this.view1_resolution_list.push(resolution_list[i])
                }
            })

        },

        // 主头拍照
        view1_scan() {
            let data = JSON.parse(JSON.stringify(this.altimeterData))
            delete data.deskewval
            delete data.deskew
            axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(data)).then((res) => {
                console.log(res)
                this.add_image(res.data.photoBase64)
            })
        },
        view2_scan() {
            axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(this.altimeterData)).then((res) => {
                console.log(res)
                this.add_image(res.data.photoBase64)
            })
        },
        add_image(img_base64) {
            console.log(img_base64)
            if (this.img_base64List.length >= 1) {
                // this.img_base64List = this.img_base64List.splice(1, 1)
                this.img_base64List.push("data:image/jpg;base64," + img_base64)
            } else {
                this.img_base64List.push("data:image/jpg;base64," + img_base64)
            }
        },
        cancelGpy() {
            this.dialogGPY = false
            this.gpy = false
        },
        // 高拍仪提交方法
        async congirmGpyFile() {
            var token = sessionStorage.getItem("token");
            this.img_base64List.forEach((key, i) => {
                var arr = key.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                var timestamp = (new Date()).valueOf()
                const formData = new FormData()
                var fileliu = new File([u8arr], timestamp + '.jpg', { type: mime })
                formData.append('file', fileliu)
                console.log(formData)
                upFile(formData, token).then((res) => {
                    if (res.status === 200) {
                        this.selectFileIds = []
                        this.selectFileIds.push(res.result[0])
                        // this.sendDataInfo.uploadVoList = this.selectFileIds
                        this.selectFileIds.forEach((i, index) => {
                            this.fileList.push({
                                ...i,
                                name: i.fileName,
                                url: this.imgUrl + "/" + i.fileUrl,

                            });
                        })
                        this.dialogGPY = false
                        // if (i == Number(this.img_base64List.length - 1)) {
                        //     this.subFileInfo()
                        // }
                    }
                });
                console.log(this.fileList, 'this.fileList');
            })
            this.dialogGPY = false
        },
        // 删除图片
        delFileImg(i) {
            imgList.splice(i, 1)
            this.imageList = imgList
        },
        // 打开高拍仪
        openHighBeatMeter() {
            console.log("打开高拍仪")
            this.imageList = []
            this.img_base64List = []
            this.gpy = true
            this.dialogGPY = true
            setTimeout(() => {
                this.switchValue = true
                this.getStatus(1)
            }, 100)
        },
        // 文件上传成功回调
        async handleAvatarSuccess(res, file, fileList) {
            // 断开与 el-upload 内部列表的引用，避免受控 file-list 不同步导致再选文件无效
            this.fileList = fileList.slice();
            if (!res || res.status == 500) {
                const index = this.fileList.findIndex((item) => item.uid === file.uid);
                if (index > -1) this.fileList.splice(index, 1);
                return this.$message.error((res && res.message) || "上传失败");
            }
            if (!res.result || !res.result[0]) {
                const index = this.fileList.findIndex((item) => item.uid === file.uid);
                if (index > -1) this.fileList.splice(index, 1);
                return this.$message.error("上传返回数据异常");
            }
            const uploadedFileInfo = res.result[0];
            // 用 uid 匹配刚上传的文件（服务端 fileName 可能与本地 name 不一致）
            let targetFile = this.fileList.find((item) => item.uid === file.uid);
            if (!targetFile) {
                targetFile = this.fileList.find(
                    (item) => item.name === uploadedFileInfo.fileName || item.name === file.name
                );
            }
            if (targetFile) {
                Object.keys(uploadedFileInfo).forEach((key) => {
                    this.$set(targetFile, key, uploadedFileInfo[key]);
                });
                this.$set(targetFile, "name", uploadedFileInfo.fileName || targetFile.name);
                this.$set(targetFile, "url", this.imgUrl + "/" + uploadedFileInfo.fileUrl);
                this.$set(targetFile, "fileUrl", uploadedFileInfo.fileUrl);
            } else {
                this.fileList.push({
                    ...uploadedFileInfo,
                    uid: file.uid,
                    name: uploadedFileInfo.fileName,
                    url: this.imgUrl + "/" + uploadedFileInfo.fileUrl,
                });
            }
            this.selectFileIds.push(uploadedFileInfo);

            // PDF 等非图片不做尺寸校验；图片加载失败也不阻塞列表
            const isImage = file.raw && file.raw.type && file.raw.type.indexOf("image/") === 0;
            if (!isImage || !file.raw) {
                return;
            }
            try {
                const img = new Image();
                const objectUrl = window.URL.createObjectURL(file.raw);
                const { w, h } = await new Promise((resolve, reject) => {
                    img.onload = () => {
                        resolve({ w: img.width, h: img.height });
                        window.URL.revokeObjectURL(objectUrl);
                    };
                    img.onerror = () => {
                        window.URL.revokeObjectURL(objectUrl);
                        reject(new Error("image load error"));
                    };
                    img.src = objectUrl;
                });
                if (h / w < 210 / 297 && w / h < 210 / 297) {
                    this.selectFileIds = this.selectFileIds.filter(
                        (item) => item.fileUrl !== uploadedFileInfo.fileUrl
                    );
                    this.fileList = this.fileList.filter(
                        (item) => item.fileUrl !== uploadedFileInfo.fileUrl && item.uid !== file.uid
                    );
                    this.$message.warning("请上传正确规格的图片");
                }
            } catch (e) {
                // 预览图加载失败时保留已上传文件，不拦截
                console.warn("图片尺寸校验跳过:", e);
            }
        },
        // 提交上传文件所有信息
        async subFileInfo() {
            console.log(this.$parent.$parent.busynessKey)
            if (this.isChange) {
                this.$parent.$parent.delFile(this.field, true)
            }
            // 筛选出已上传成功的文件（有fileUrl的文件）
            const uploadedFiles = this.fileList
                .filter(item => item.fileUrl)
                .map(item => ({
                    bgmName: item.bgmName || "",
                    busType: item.busType || "",
                    codingNum: item.codingNum || "",
                    createTime: item.createTime || "",
                    creater: item.creater || "",
                    createrName: item.createrName || "",
                    fileId: item.fileId || "",
                    fileName: item.fileName || "",
                    fileType: item.fileType || "",
                    fileUrl: item.fileUrl || "",
                    type: item.type || ""
                }))
            let params = {
                busynessKey: this.$parent.$parent.busynessKey.toString(),
                busynessId: this.$parent.$parent.fileIds.toString(),
                fileType: this.$parent.$parent.upType,
                uploadVoList: uploadedFiles,
                ormId: this.$parent.$parent.ormId || "",
                codingNum: this.codingNum
            }
            let responseData
            if (this.upDataUrl) {
                responseData = await this.$http[this.upDataUrl](params);
            } else {
                responseData = await this.$http.subFileInfo(params);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: '上传成功',
                    type: "success",
                });
                this.$parent.$parent.getFileListByIds()
                this.dialogGPY = false
                this.diaFile = false
                imgList = []
                this.fileList = []
                this.codingNum = ""
                this.imageList = imgList
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 文件上传服务器
        submitUpload() {
            this.subFileInfo()
        },
        // 打开文件上传弹窗
        openFileDia(codingNum, field, row, type) {

            this.codingNum = ''
            if (codingNum) {
                this.isChange = true
                this.codingNum = codingNum
                this.field = field
            }
            if (type != 1) {
                this.fileList = []
                this.selectFileIds = []
            } else {
                this.fileList = []
                this.selectFileIds = []
                this.selectFileIds.push(row)
                this.selectFileIds.forEach((i, index) => {
                    this.fileList.push({
                        name: i.fileName,
                        url: this.imgUrl + "/" + i.fileUrl,
                    });
                })


            }
            imgList = []
            this.imageList = imgList
            this.diaFile = true


        },
        handleClose(done) {
            this.$confirm('确认取消文件上传？')
                .then(_ => {
                    this.diaFile = false
                    socket.close()
                    imgList = []
                    this.img_base64List = imgList
                    done();

                })
                .catch(_ => { });
        },
        handleClosegpy(done) {
            this.$confirm('确认取消文件上传？')
                .then(_ => {
                    this.dialogGPY = false
                    socket.close()
                    imgList = []
                    this.img_base64List = imgList
                    done();

                })
                .catch(_ => { });
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.fileList.forEach((item, index) => {
                if (file.uid == item.uid) {
                    this.fileList.splice(index, 1)
                }
            })
        },
        handlePreview(file) {
            console.log(file.url);
            this.imageUrl = file.url
            this.dialogImg = true
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 20 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        //获取图片存取的根路径
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        initVidio() {
            // 加载主摄像头视频模式
            let view1_mode_data1 = { "camidx": "0", "mode": "0" };
            let view1_mode_data2 = { "camidx": "0", "mode": "1" };
            axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(view1_mode_data2)).then((res) => {
                if (res.data.data.split("|").length > 1) {
                    let data = new Object()
                    data.key = '1'
                    data.value = 'MJPG'
                    this.view1_mode_list.push(data)

                }
            })
            // axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(view1_mode_data1)).then((res)=>{
            //   if(res.data.data.split("|").length > 1){
            //     let data = new Object()
            //     data.key = '0'
            //     data.value = 'YUY2'
            //     this.view1_mode_list.push(data)
            //   }
            // })
        },
    },
    //监听属性 类似于data概念
    computed: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgurl()
        this.initVidio()
        this.printScanShow = window.global_config.printScanShow ? true : false
        this.isGPY = window.global_config.isGPY ? true : false
        this.altimeterData.deskewval=window.global_config.isDeskewval||false
    },
    mounted() { }, //生命周期 - 挂载完成（可以访问DOM元素）
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.head {
    display: flex;
    align-items: center;
}

.updata {
    margin-left: 80px;
    margin-top: 10px;
}

.imgBox {
    display: flex;
}

.gimage {
    margin-left: 20px;
    position: relative;
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
}

.err {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
    z-index: 999;
    color: red;
    cursor: pointer;
}

.showimg {
    width: 360px;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
}

.view-warp {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
}

/* 全局 */
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 10px;
}

/* 视频预览 */
#view1,
#view2 {
    height: 300px;
    border: 1px solid #000;
    margin-right: 5px;
}

/* 缩略图 */
#suoluetu {
    width: 460px;
    display: flex;
    flex-wrap: wrap;
    height: 300px;
    overflow-y: auto;
}

#suoluetu .imgList {
    width: 100px;
    height: 140px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    margin: 5px;
}

/* 操作按钮 */
#myactive {
    /* border: 1px solid yellowgreen; */
    margin-top: 10px;
    padding: 10px 5px;
}

/* 操作日志 */
#mylog {
    border: 1px solid black;
    padding: 10px;
    margin-top: 10px;
    overflow: auto;
}
</style>
<style scoped>
.el-select {
    width: 150px !important;
}

::v-deep .el-upload-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

::v-deep .el-upload-list--picture .el-upload-list__item {
    width: 220px;
    height: 70px;
    margin-right: 5px;
}

::v-deep .el-upload-list--picture .el-upload-list__item-thumbnail {
    width: 50px;
    height: 50px;
    margin-left: -50px;
}

::v-deep
    .el-upload-list--picture
    .el-upload-list__item.is-success
    .el-upload-list__item-name {
    line-height: 50px;
}

::v-deep .el-upload-list--picture .el-upload-list__item {
    padding: 10px 10px 10px 60px;
}
</style>
